<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="billTable"
      :custom-on-row-click="goNext"
      :entity-name="$t('allBills')"
      :icon="'mdi-format-list-bulleted'"
      :model="model"
      :required-date-value="dates"
      :use-date-filter="true"
      :use-default-action="false"
      :use-select="false"
      style="width: 100%"
    >
      <template #footer="{tableItems,dateTime}">
        <v-btn
          class="primary mr-2"
          elevation="0"
          @click="print(dateTime)"
        >
          {{ $t('print') }}
        </v-btn>
        <v-card
          class="ml-2 pa-2 px-4 d-flex align-center"
          elevation="0"
          outlined
          style="background: white;border-radius: 24px !important;"
        >
          {{ $t('sumAmount') }}：€{{ calculateTotalPaymentPrice(tableItems).toFixed(2) }}
        </v-card>
      </template>
    </ik-data-table>
    <v-navigation-drawer
      v-model="showDetail"
      app
      color="#fafbfc"
      right
      temporary
      touchless
      width="calc(100vw - 350px)"
    >
      <v-card
        v-if="showDetail"
        color="#f6f6f6"
        tile
      >
        <bill-detail-page
          :id="currentOrderId"
          :order="currentOrder"
          @close-reload="reload"
        >
          <template #navigation>
            <v-btn
              class="mr-4 rounded"
              height="36px"
              icon
              outlined
              tile
              width="36px"
              @click="showDetail=false"
            >
              <v-icon size="24">
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
        </bill-detail-page>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>

  import { printSummaryBon } from '@/common/Utlis/api'
  import IKUtils from 'innerken-js-utils'
  import HistoryBills from '../../../../model/bills/HistoryBills'
  import { IkDataTable } from 'metaflow-js'
  import BillDetailPage from './BillDetailPage'
  import { today } from 'metaflow-js/EntityFrameWork/DateRepository'
  import { showSuccessMessage } from '@/common/utils'

  export default {
    components: {

      BillDetailPage,
      IkDataTable,
    },
    data: function () {
      return ({
        model: HistoryBills,
        dates: [today, today],
        showDetail: null,
        currentOrderId: null,
        currentOrder: null,
      })
    },
    async mounted () {
      this.dates = [today, today]
    },
    methods: {
      calculateTotalPaymentPrice (items) {
        if (!this.$refs.billTable || !this.$refs.billTable.filterItem.paymentArr ||
          (this.$refs.billTable.filterItem.paymentArr.length === 0)) {
          return items?.reduce(
            (arr, item) =>
              parseInt(item.consumeTypeStatusId) === 6 ? arr + parseFloat(item.totalPrice) : arr
            , 0) ?? 0
        } else {
          const paymentArr = this.$refs.billTable.filterItem.paymentArr
          let totalMoney = 0
          paymentArr.forEach(indexItem => {
            for (const item of items) {
              if (item.payLogs !== null) {
                item.payLogs.forEach(payItem => {
                  if (parseInt(payItem.paymentMethodId) === parseInt(indexItem)) {
                    totalMoney += parseFloat(payItem.amount)
                  }
                })
              }
            }
          })
          return totalMoney
        }
      },
      goNext (item) {
        this.showDetail = true
        this.currentOrderId = item.orderId
        this.currentOrder = item
      },
      reload () {
        this.showDetail = false
        this.$refs.billTable.reload()
      },

      async print (dates) {
        const timeSpan = { timespan: dates.join(' - ') }
        await IKUtils.showConfirm('Bist du sicher?', 'Möchten Sie alle Datensätze drucken?', () => {
          printSummaryBon(timeSpan)
          showSuccessMessage('Erfolgreich drucken!')
        })
      },

    },
  }
</script>
